import { AdminAuditLog } from '@hakimo-ui/hakimo/types';
import { Column, TableData } from '@hakimo-ui/hakimo/ui-table';
import { AdminAuditLogFilters } from './types';

export const PAGE_SIZE = 15;

export const columns: Column[] = [
  {
    id: 'timestamp',
    name: 'Timestamp',
  },
  {
    id: 'activity',
    name: 'Activity',
  },
  {
    id: 'triggeredBy',
    name: 'Triggered By',
    showAtBreakpoint: 'lg',
  },
  {
    id: 'tenant',
    name: 'Tenant Name',
  },
];

export function getTableData(items: AdminAuditLog[]): TableData {
  return {
    columns,
    rows: items.map((item) => ({
      id: String(item.id),
      cells: [
        { value: item.timestamp },
        {
          value: (
            <div className="max-w-4xl whitespace-normal break-words">
              {item.activity}
            </div>
          ),
        },
        { value: item.userEmail },
        { value: item.tenantName ?? item.tenantId ?? '-' },
      ],
    })),
  };
}

export function getSearchParams(
  filters: AdminAuditLogFilters,
  page: number,
  pageSize: number
): string {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(pageSize));

  if (filters.tenantName) {
    params.append('tenantName', filters.tenantName);
  }

  return params.toString();
}
